// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const panpour: PokeData = {
  "id": 515,
  "name": "panpour",
  "height": 6,
  "weight": 135,
  "base_experience": 63,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "leer",
    "bite",
    "water-gun",
    "lick",
    "fury-swipes",
    "crunch",
    "taunt",
    "recycle",
    "water-sport",
    "brine",
    "natural-gift",
    "fling",
    "scald",
    "acrobatics",
    "play-nice"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "lick",
    "crunch",
    "brine",
    "acrobatics",
    "aqua-tail",
    "bubble",
    "whirlpool",
    "bubble-beam",
    "liquidation",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 264,
    "item": null,
    "species": [
      {
        "name": "panpour",
        "order": 516,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simipour",
        "order": 517,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 515,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49,
    "speed": 64,
    "ability_power": 53
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
